module.exports = __webpack_public_path__ + "img/monitorbox25.42341871.jpg";